import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import { initWebVitals } from './utils/webVitals';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
);

// Initialize Core Web Vitals monitoring (logs to console)
initWebVitals();
